import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
//page
import Nav from './Nav';//img


export default function JugementParisVendredi() {
    const [question0, setQuestion0] = useState(true);
    const [question1, setQuestion1] = useState(false);
    const [resultat1, setResultat1] = useState(false);
    const [question2, setQuestion2] = useState(false);
    const [resultat2, setResultat2] = useState(false);
    const [question3, setQuestion3] = useState(false);
    const [resultat3, setResultat3] = useState(false);
    const [coupable, setCoupable] = useState(false);
    const [genre, setGenre] = useState(null);
    const [age, setAge] = useState(null);

    //messages succes ou erreur
    const [calcul, setCalcul] = useState(null);

    // Un bouton sélectionnable réutilisable
    function SelectButton({ label, value, selected, onSelect }) {
        return (
            <button
                onClick={() => onSelect(value)}
                className={`px-6 py-2.5 text-sm font-semibold rounded-lg border-2 
        ${selected === value
                        ? "bg-black text-white border-black"
                        : "bg-transparent text-black border-black hover:bg-black hover:text-white"
                    }`}
            >
                {label}
            </button>
        );
    }
    useEffect(() => {
  // Si on est sur la question 0 et que genre + age sont remplis
  if (question0 && genre && age) {
    setQuestion0(false);
        setQuestion1(true);
  }
  console.log("genre et age", genre, age);
}, [genre, age]);


    const location = useLocation();
    //console.log(location.pathname);
    const URL = `https://api.airtable.com/v0/appdSwprfbQowxVAW/votes`;



    function rep1(reponse) {
        console.log("reponse 1", reponse);
        if (reponse === "oui") {
            setQuestion1(false);
            setQuestion2(true);
        } else if (reponse === "non") {
            //jugement non coupable
            const enregistrementVote = async () => {
                try {
                    const response = await fetch(URL, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
                            "Accept": "application/json",
                            'content-type': "application/json"
                        },
                        body: JSON.stringify({
                            "fields": {
                                "lieu": "paris",
                                "date_representation": "28/11/2025",
                                "jugement": "non coupable",
                                "url": location.pathname,
                                "genre": genre,
                            "age": age,
                            }
                        })
                    });
                    const resp = await response.json();
                    console.log("res vote", resp);
                    if (resp) {
                        setQuestion1(false);
                        setResultat1(true);
                        setCalcul(true);
                    }

                } catch (e) {
                    console.log(e);
                }
            };
            enregistrementVote();
        }
    }
    function rep2(reponse) {
        console.log("reponse 2", reponse);
        if (reponse === "non") {
            setQuestion2(false);
            setQuestion3(true);
        } else if (reponse === "oui") {
            //jugement coupable mais excuse de vérité
            const enregistrementVote = async () => {
                try {
                    const response = await fetch(URL, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
                            "Accept": "application/json",
                            'content-type': "application/json"
                        },
                        body: JSON.stringify({
                            "fields": {
                                "lieu": "paris",
                                "date_representation": "28/11/2025",
                                "jugement": "coupable excuse verité",
                                "url": location.pathname,
                                "genre": genre,
                            "age": age,
                            }
                        })
                    });
                    const resp = await response.json();
                    console.log("res vote", resp);
                    if (resp) {
                        setQuestion2(false);
                        setResultat2(true);
                        setCalcul(true);
                    }

                } catch (e) {
                    console.log(e);
                }
            };
            enregistrementVote();

        }
    }
    function rep3(reponse) {
        console.log("reponse 3", reponse);
        if (reponse === "non") {
            //jugement coupable et condamnée
            const enregistrementVote = async () => {
                try {
                    const response = await fetch(URL, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
                            "Accept": "application/json",
                            'content-type': "application/json"
                        },
                        body: JSON.stringify({
                            "fields": {
                                "lieu": "paris",
                                "date_representation": "28/11/2025",
                                "jugement": "coupable et condamnée",
                                "url": location.pathname,
                                "genre": genre,
                            "age": age,
                            }
                        })
                    });
                    const resp = await response.json();
                    console.log("res vote", resp);
                    if (resp) {
                        setQuestion3(false);
                        setCoupable(true);
                        setCalcul(true);
                    }

                } catch (e) {
                    console.log(e);
                }
            };
            enregistrementVote();

        } else if (reponse === "oui") {
            //jugement coupable mais excuse de bonne foi
            const enregistrementVote = async () => {
                try {
                    const response = await fetch(URL, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
                            "Accept": "application/json",
                            'content-type': "application/json"
                        },
                        body: JSON.stringify({
                            "fields": {
                                "lieu": "paris",
                                "date_representation": "28/11/2025",
                                "jugement": "coupable excuse bonne foi",
                                "url": location.pathname,
                                "genre": genre,
                            "age": age,
                            }
                        })
                    });
                    const resp = await response.json();
                    console.log("res vote", resp);
                    if (resp) {
                        setQuestion3(false);
                        setResultat3(true);
                        setCalcul(true);
                    }

                } catch (e) {
                    console.log(e);
                }
            };
            enregistrementVote();

        }
    }




    return (
        <>
            <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
                <Nav />

                <div className="relative isolate px-6 pt-14 lg:px-8">

                    <div className="mx-auto max-w-7xl py-32">
                        <div className="text-left">
                            <h1 className="text-balance text-[80px] leading-[5.5rem] font-semibold tracking-tight text-white  max-w-[80%] ">
                                Devenez juré.e
                            </h1>
                            <p className='text-white'>Votez pour déterminer si Madame Gaber doit ou non être condamnée pour diffamation.</p>

                            {/** jugement */}
                            <div className='mt-12'>
                                <p className='ss-titre'>Pour déterminer si Madame Gaber est coupable de diffamation, vous devez répondre à 3 questions</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/** questions */}
                <div class="relative ">
                    {question0 === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#CB40A6] p-6">
                            {/** question 0 */}
                            <div className='mx-auto max-w-7xl py-32'>
                                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-black ring-2 ring-inset ring-black mb-6">
                                    Tout d'abord
                                </span>
                                <p className="ss-titre text-black mt-6">Quel est votre genre ?</p>

                                <div className='flex gap-6 justify-start mt-6  flex-wrap'>
                                    <SelectButton
                                        label="Homme"
                                        value="homme"
                                        selected={genre}
                                        onSelect={setGenre}
                                    />
                                    <SelectButton
                                        label="Femme"
                                        value="femme"
                                        selected={genre}
                                        onSelect={setGenre}
                                    />
                                    <SelectButton
                                        label="Autre"
                                        value="non-binaire"
                                        selected={genre}
                                        onSelect={setGenre}
                                    />
                                    <SelectButton label="Je ne préfère pas répondre" value="pas-reponse" selected={genre} onSelect={setGenre} />
                                </div>

                                <div className='mx-auto max-w-7xl mt-10'>
                                    <p className="ss-titre text-black mt-6">Quel est votre âge ?</p>

                                    <div className='flex gap-6 flex-wrap justify-start mt-6'>
                                        <SelectButton label="moins de 18 ans" value="-18" selected={age} onSelect={setAge} />
                                        <SelectButton label="18–24 ans" value="18-24" selected={age} onSelect={setAge} />
                                        <SelectButton label="25–34 ans" value="25-34" selected={age} onSelect={setAge} />
                                        <SelectButton label="35–44 ans" value="35-44" selected={age} onSelect={setAge} />
                                        <SelectButton label="45–54 ans" value="45-54" selected={age} onSelect={setAge} />
                                        <SelectButton label="55 ans et +" value="55+" selected={age} onSelect={setAge} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}

                    {question1 === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#CB40A6] p-6">
                            {/** question 1 */}
                            <div className='mx-auto max-w-7xl py-32'>
                                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-black ring-2 ring-inset ring-black mb-6">
                                    Question 1
                                </span>
                                <p className="ss-titre text-black mt-6">Jugez-vous que Madame Gaber, en publiant le hashtag <i>#cheniercultureduviol</i>, a porté atteinte à l’honneur et à la considération de Monsieur Chénier ?</p>
                                <div className='flex gap-6 justify-start mt-6'>
                                    <a onClick={() => { rep1("oui"); }} className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>Oui</a>
                                    <a onClick={() => { rep1("non"); }} className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>Non</a>
                                </div>
                            </div>
                        </div>
                    </>}
                    {question2 === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#D9D9D9] p-6">
                            {/** question 2 */}
                            <div className='mx-auto max-w-7xl py-32'>
                                <p className="mb-10 sm:text-[20px]">Vous reconnaissez donc Madame Gaber coupable de diffamation, néanmoins, en droit français il existe ce que l’on appelle des excuses de diffamation pour éviter la condamnation.</p>
                                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-black ring-2 ring-inset ring-black mb-6">
                                    Question 2
                                </span>
                                <p className="ss-titre text-black mt-6">Jugez-vous que le poème de Monsieur Chénier participe à la perpétuation de la culture du viol ?</p>
                                <div className='flex gap-6 justify-start mt-6'>
                                    <a onClick={() => { rep2("oui"); }} className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>Oui</a>
                                    <a onClick={() => { rep2("non"); }} className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>Non</a>
                                </div>
                            </div>
                        </div>
                    </>}
                    {question3 === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#511277] p-6">
                            {/** question 3 */}
                            <div className='mx-auto max-w-7xl py-32'>
                                <p className="mb-10 text-white sm:text-[20px]">Vous estimez que l'excuse de vérité ne s'applique pas. Il y a toutefois une seconde excuse possible : l’excuse de bonne foi. Elle implique de répondre à la question suivante :</p>
                                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-white ring-2 ring-inset ring-white mb-6">
                                    Question 3
                                </span>
                                <p className="ss-titre text-white mt-6">Jugez-vous que Madame Gaber, en publiant le hashtag <i>#cheniercultureduviol</i>, a soulevé une question d’intérêt général ET a été mesurée dans son expression ? </p>
                                <div className='flex gap-6 justify-start mt-6'>
                                    <a onClick={() => { rep3("oui"); }} className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>Oui</a>
                                    <a onClick={() => { rep3("non"); }} className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>Non</a>
                                </div>
                            </div>
                        </div>
                    </>}
                    {/********************************** resultat ***********************************/}
                    {resultat1 === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent  p-6">
                            <div className='mx-auto max-w-2xl py-32'>
                                <p className="ss-titre mb-8">
                                    Vous déclarez Madame Gaber
                                </p>
                                {/** card */}
                                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                                    <p className='text-[50px] font-bold mb-4'>Non coupable de diffamation</p>
                                </div>
                                <p className="text-white mt-4">Les résultats de votre représentation<br /><b>Paris le 28 novembre 2025</b></p>
                                <p className="text-white"> En cours de calcul ...</p>
                                {/**<ul className="flex flex-row gap-3 justify-stretch flex-wrap mt-4">
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                </ul>**/}
                            </div>
                        </div>
                    </>}
                    {resultat2 === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent p-6">
                            <div className='mx-auto max-w-2xl py-32'>
                                <p className="ss-titre mb-8">
                                    Vous déclarez Madame Gaber
                                </p>
                                {/** card */}
                                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                                    <p className='text-[50px] font-bold mb-4'>Coupable mais échappant à la condamnation</p>
                                    <p className='text-[20px] font-normal mt-[20px]'>Au titre de l'excuse de vérité </p>
                                </div>
                                <p className="text-white mt-4">Les résultats de votre représentation<br /><b>Paris le 28 novembre 2025</b></p>
                                <p className="text-white"> En cours de calcul ...</p>
                                {/**<ul className="flex flex-row gap-3 justify-stretch flex-wrap mt-4">
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                </ul>**/}
                            </div>
                        </div>
                    </>}
                    {resultat3 === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent p-6">
                            <div className='mx-auto max-w-2xl py-32'>
                                <p className="ss-titre mb-8">
                                    Vous déclarez Madame Gaber
                                </p>
                                {/** card */}
                                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                                    <p className='text-[50px] font-bold mb-4'>Coupable mais échappant à la condamnation</p>
                                    <p className='text-[20px] font-normal mt-[20px]'>Au titre de l’excuse de bonne foi  </p>
                                </div>
                                <p className="text-white mt-4">Les résultats de votre représentation<br /><b>Paris le 28 novembre 2025</b></p>
                                <p className="text-white"> En cours de calcul ...</p>
                                {/**<ul className="flex flex-row gap-3 justify-stretch flex-wrap mt-4">
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                </ul>**/}
                            </div>
                        </div>
                    </>}
                    {coupable === true && <>
                        <div class="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent p-6">
                            <div className='mx-auto max-w-2xl py-32'>
                                <p className="ss-titre mb-8">
                                    Vous déclarez Madame Gaber
                                </p>
                                {/** card */}
                                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                                    <p className='text-[50px] font-bold mb-4'>Coupable de diffamation et condamnée </p>
                                </div>
                                <p className="text-white mt-4">Les résultats de votre représentation<br /><b>Paris le 28 novembre 2025</b></p>
                                <p className="text-white"> En cours de calcul ...</p>
                                {/**<ul className="flex flex-row gap-3 justify-stretch flex-wrap mt-4">
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                    <li className="border-2 border-white p-3 rounded-sm text-white">23% non coupable </li>
                                </ul>**/}
                            </div>
                        </div>
                    </>}


                </div>{/** end relative */}
            </div>

        </>
    )
}
